/* Xavleg size chart pop-up (Oct 2026). Pairs with snippets/xv-size-chart.liquid */
(function () {
  if (window.__xvSizeChart) return;
  window.__xvSizeChart = true;

  var NUM_CELL = /^\s*\d+(?:\.\d+)?(?:\s*(?:to|-|–)\s*\d+(?:\.\d+)?)?\s*$/i;
  var lastOpener = null;

  function toCm(text) {
    return text.replace(/\d+(?:\.\d+)?/g, function (n) {
      return (parseFloat(n) * 2.54).toFixed(1);
    });
  }

  // Rebuild the description table as a clean table (no pasted classes or inline sizes)
  // and remember the inch values so we can flip between inches and cm.
  function enhance(dialog) {
    if (dialog.dataset.xvReady) return;
    dialog.dataset.xvReady = '1';
    var wrap = dialog.querySelector('[data-xv-sc-table]');
    var raw = wrap && wrap.querySelector('table');
    if (!raw) return;
    try {
      var rows = Array.prototype.slice.call(raw.querySelectorAll('tr'));
      if (!rows.length) return;
      var table = document.createElement('table');
      var thead = document.createElement('thead');
      var tbody = document.createElement('tbody');
      var hasNumbers = false;
      rows.forEach(function (tr, ri) {
        var cells = Array.prototype.slice.call(tr.children);
        var isHead = ri === 0 && (tr.closest('thead') || cells.every(function (c) { return c.tagName === 'TH'; }));
        var row = document.createElement('tr');
        cells.forEach(function (c, ci) {
          var cell = document.createElement(isHead ? 'th' : 'td');
          if (isHead) cell.setAttribute('scope', 'col');
          var text = (c.textContent || '').replace(/\s+/g, ' ').trim();
          cell.textContent = text;
          if (isHead && /\((in|inches)\)/i.test(text)) {
            cell.setAttribute('data-xv-in', text);
            cell.setAttribute('data-xv-cm', text.replace(/\((in|inches)\)/i, '(cm)'));
          } else if (!isHead && ci > 0 && NUM_CELL.test(text)) {
            hasNumbers = true;
            cell.setAttribute('data-xv-in', text);
            cell.setAttribute('data-xv-cm', toCm(text));
          }
          row.appendChild(cell);
        });
        (isHead ? thead : tbody).appendChild(row);
      });
      if (thead.children.length) table.appendChild(thead);
      table.appendChild(tbody);
      wrap.innerHTML = '';
      wrap.appendChild(table);

      var note = dialog.querySelector('[data-xv-note]');
      if (note) {
        note.setAttribute('data-xv-in', note.textContent);
        note.setAttribute(
          'data-xv-cm',
          note.textContent.replace(/(\d+(?:\.\d+)?)\s*(?:"|”|in\b)/g, function (_, n) {
            return (parseFloat(n) * 2.54).toFixed(1) + ' cm';
          })
        );
      }

      var units = dialog.querySelector('.xv-sc__units');
      if (units && hasNumbers) units.hidden = false;
    } catch (e) {
      /* If anything goes wrong the original table stays visible. */
    }
  }

  function setUnit(dialog, unit) {
    dialog.querySelectorAll('[data-xv-in]').forEach(function (el) {
      el.textContent = el.getAttribute(unit === 'cm' ? 'data-xv-cm' : 'data-xv-in');
    });
    dialog.querySelectorAll('[data-xv-unit]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-xv-unit') === unit ? 'true' : 'false');
    });
    var label = dialog.querySelector('[data-xv-unit-label]');
    if (label) label.textContent = unit === 'cm' ? 'centimetres' : 'inches';
    try { localStorage.setItem('xvSizeUnit', unit); } catch (e) {}
  }

  function open(dialog, opener) {
    enhance(dialog);
    var saved = null;
    try { saved = localStorage.getItem('xvSizeUnit'); } catch (e) {}
    setUnit(dialog, saved === 'cm' ? 'cm' : 'in');
    lastOpener = opener || null;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('xv-sc-lock');
    var closeBtn = dialog.querySelector('[data-xv-sc-close]');
    if (closeBtn) closeBtn.focus();
  }

  function close(dialog) {
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var opener = t.closest('[data-xv-sc-open]');
    if (opener) {
      var d = document.getElementById(opener.getAttribute('data-xv-sc-open'));
      if (d) { e.preventDefault(); open(d, opener); }
      return;
    }
    var dialog = t.closest('dialog.xv-sc');
    if (!dialog) return;
    if (t.closest('[data-xv-sc-close]')) { close(dialog); return; }
    var unitBtn = t.closest('[data-xv-unit]');
    if (unitBtn) { setUnit(dialog, unitBtn.getAttribute('data-xv-unit')); return; }
    // Click on the backdrop (the dialog box itself, outside the inner panel) closes it.
    if (t === dialog) {
      var r = dialog.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside || !dialog.querySelector('.xv-sc__inner').contains(t)) close(dialog);
    }
  });

  // Esc is handled by <dialog> natively; tidy up whenever it closes.
  document.addEventListener(
    'close',
    function (e) {
      if (!e.target.classList || !e.target.classList.contains('xv-sc')) return;
      document.documentElement.classList.remove('xv-sc-lock');
      if (lastOpener && document.contains(lastOpener)) lastOpener.focus();
    },
    true
  );

  // Keep Tab inside the dialog (belt and braces; showModal already makes the page inert).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var dialog = document.querySelector('dialog.xv-sc[open]');
    if (!dialog) return;
    var f = Array.prototype.filter.call(
      dialog.querySelectorAll('button:not([disabled]):not([hidden]), [href], [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Deep link: /products/...#size-chart opens the chart straight away.
  function openFromHash() {
    if (location.hash !== '#size-chart') return;
    var opener = document.querySelector('[data-xv-sc-open]');
    var d = opener && document.getElementById(opener.getAttribute('data-xv-sc-open'));
    if (d) open(d, opener);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromHash);
  else openFromHash();
  window.addEventListener('hashchange', openFromHash);
})();
